import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useToasterContext } from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import { useUpdateAlert } from "src/hooks"
import { GenericErrorToast } from "src/toasts"

export function useOnAddPhone(
  primaryPhone: Phone | undefined,
  maxPhoneNumbers: number,
  sugarmateAlert: Alert,
) {
  const { showToast } = useToasterContext()

  const updateAlert = useUpdateAlert(
    primaryPhone,
    sugarmateAlert,
  )

  // attempt to automatically assign a newly created or promoted phone to this alert
  return useCallback(
    async (phoneId: Phone["id"]) => {
      if (sugarmateAlert.phone_ids.length >= maxPhoneNumbers) {
        return
      }

      try {
        if (!updateAlert) {
          throw new Error("cannot update alert")
        }

        const newPhoneIds = new Set(sugarmateAlert.phone_ids.concat(phoneId))
        await updateAlert({ phone_ids: [...newPhoneIds] })
      } catch {
        showToast(
          "automatically-assign-phone-to-alert-error-toast",
          GenericErrorToast,
        )
      }
    },
    [
      updateAlert,
      maxPhoneNumbers,
      sugarmateAlert.phone_ids,
      showToast,
    ],
  )
}
